export default "__VITE_ASSET__1wEg6mIV__"